import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { isDefined } from "../helper";


@Injectable()
export class StorageProvider {

    constructor(private storage: Storage) {
        //console.log('Hello storage Provider');

    }

    get(key) {
        return new Promise((Resolve, Reject) => {
            this.onReady().then(() => {
                this.storage.get(key).then((val) => {
                    Resolve(isDefined(val) ? val : null);
                });
            }, (err) => Resolve(null));
        });
    }

    set(key: string, value) {
        return new Promise((Resolve, Reject) => {
            this.storage.set(key, value).then(() => {
                Resolve(true);
            }, () => {
                Resolve(false);
            });
        });
    }

    remove(key) {
        return new Promise((Resolve, Reject) => {
            this.storage.remove(key).then((val) => {
                Resolve(true);
            }, (err) => Resolve(false));
        });
    }

    onReady() {
        return this.storage.ready();
    }

}


// WEBPACK FOOTER //
// ./src/providers/storage/storage.ts